export default {
  isAuthenticated(state){
    return state.signedIn;
  },

  getUser(state){
    return state.curUser;
  },

  getWebUser(state){
    return state.webUser;
  },

  getMenuItems:state=>role=> {

      var menuItems = [];
      let ordersItem = {title: 'Заявки', name: "Requests", icon: "clipboard"}
      let chatItem = {title: 'Заказы', name: "Orders", icon: "forum"}
      let stockItem = {title: 'Акции', name: "Stocks", icon: "stock"}
      let clients = {title: 'Клиенты', name: "Clients", icon: "account-multi-plus"}
      let partners = {title: 'Партнеры', name: "Partners", icon: "home"}
      let activateBonus= {title:'Бонусы', name:'ActivateBonus', icon:'gift'}

      let dirBranches={title: 'Филиалы', name: "Branches" }
      let dirAuto = {title: 'Автомобили', name: "Cars", icon: "dashboard"}
      let dirCities = {title: 'Города', name: "Cities", icon: "dashboard"}
      let dirFines = {title: 'Штрафы', name: "Fines", icon: "dashboard"}
      let dirBonuses = {title: 'Бонусные пакеты', name: "Bonuses", icon: "dashboard"}
      let dirStaff = {title: 'Сотрудники', name: "Staff", icon: "dashboard"}


      if (role == 'RequestExecutor' || role.indexOf('RequestExecutor') != -1) {
          menuItems.push(ordersItem,
              activateBonus,
              chatItem)
      }

      if (role == 'UserManager' || role.indexOf('UserManager') != -1) {
          menuItems.push(clients)
          menuItems.push({
              title: 'Справочники',
              name: "directories",
              icon: "dots-horizontal",
              childrens: [dirAuto]
          })
      }

      if (role == 'Support' || role.indexOf('Support') != -1) {
          menuItems = [{title: 'Заявки', name: "Requests", icon: "clipboard"},
              stockItem,
              {
                  title: 'Справочники',
                  name: "directories",
                  icon: "dots-horizontal",
                  childrens: [
                      dirStaff,
                      dirFines,
                      dirAuto,
                      dirCities,
                      dirBonuses,
                  ]
              }];
      }

      if (role == 'BonusManager' || role.indexOf('BonusManager') != -1) {
          menuItems.push({title: 'Управление бонусами', name: "BonusManagement", icon: "stars"});
      }

      if (role == 'Administrator' || role.indexOf('Administrator') != -1) {
          menuItems = [activateBonus, partners,ordersItem,
              chatItem,
              clients,
              stockItem,
              {
                  title: 'Справочники',
                  name: "directories",
                  icon: "dots-horizontal",
                  childrens: [
                      dirStaff,
                      dirAuto,
                      dirFines,
                      dirCities,
                      dirBonuses,
                  ]
              }];
      }

      return menuItems;
  }
}
